import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ConfirmProvider } from "./components/ConfirmProvider";

// Design tokens (colours, type, spacing) come straight from the design system
// so the app stays in lockstep with the supplied designs.
import "../ds/colors_and_type.css";
import "./styles/app.css";

// Track the *visual* viewport height in a CSS var so modals can size themselves
// to the space above the on-screen keyboard. On iOS the layout viewport (100vh)
// doesn't shrink when the keyboard opens, so without this the lower half of a
// modal sits behind the keyboard with no way to scroll to it.
function syncVisualViewport() {
  const vv = window.visualViewport;
  const h = vv ? vv.height : window.innerHeight;
  document.documentElement.style.setProperty("--vvh", `${h}px`);
}
if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", syncVisualViewport);
  window.visualViewport.addEventListener("scroll", syncVisualViewport);
}
window.addEventListener("resize", syncVisualViewport);
syncVisualViewport();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </BrowserRouter>
  </StrictMode>,
);
